import React from "react";
import {Table, Checkbox} from "semantic-ui-react";
import { useUpdateTalkgroupMutation } from "../features/api/apiSlice";

// ----------------------------------------------------

// ----------------------------------------------------
const ListTalkgroups = ({ talkgroups, shortName }) => {
  const [updateTalkgroup, { isLoading }] = useUpdateTalkgroupMutation();

  const handleTranscribeToggle = async (talkgroup, checked) => {
    try {
      await updateTalkgroup({
        shortName,
        talkgroupId: talkgroup._id,
        update: { transcribe: checked }
      }).unwrap();
    } catch (e) {
      console.error("Failed to update talkgroup transcribe:", e);
    }
  };

  if (!talkgroups) return (<div/>);

  return (
    <Table celled>
      <Table.Header>
        <Table.Row>
          <Table.HeaderCell>Decimal</Table.HeaderCell>
          <Table.HeaderCell>Alpha Tag</Table.HeaderCell>
          <Table.HeaderCell>Description</Table.HeaderCell>
          <Table.HeaderCell>Transcribe</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {talkgroups.map((talkgroup, i) => (
          <Table.Row key={talkgroup.num + "-" + i}>
            <Table.Cell>{talkgroup.num}</Table.Cell>
            <Table.Cell>{talkgroup.alpha}</Table.Cell>
            <Table.Cell>{talkgroup.description}</Table.Cell>
            <Table.Cell>
              <Checkbox
                toggle
                checked={!!talkgroup.transcribe}
                disabled={isLoading}
                onChange={(e, data) => handleTranscribeToggle(talkgroup, data.checked)}
              />
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table>
  );
};

export default ListTalkgroups;
